"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeModificationRequestDeliverable = void 0;
const luxon_1 = require("luxon");
const ModificationRequestDeliverable_1 = require("../entity/ModificationRequest/ModificationRequestDeliverable");
const creative_1 = require("./creative");
const createSomeModificationRequestDeliverable = ({ id = '123', creative = creative_1.createSomeCreative(), attachedThumbnail = creative_1.createSomeCreative(), intent = 'Manners... maketh... man.', createdAt = luxon_1.DateTime.fromMillis(1516701938909, { zone: 'utc' }), } = {}) => new ModificationRequestDeliverable_1.default({
    id,
    creative,
    attachedThumbnail,
    intent,
    createdAt,
});
exports.createSomeModificationRequestDeliverable = createSomeModificationRequestDeliverable;
